import React from 'react';

const URL_RE = /((?:https?:\/\/|meet\.google\.com\/)[^\s<>"']+)/g;

/* Renders plain text with URLs (incl. bare meet.google.com links) as clickable anchors. */
export const Linkify = ({ text, className = 'font-semibold text-[#2663eb] underline underline-offset-2 break-all hover:text-[#1d4fc4]' }) => {
  const parts = String(text || '').split(URL_RE);
  return (
    <>
      {parts.map((part, i) => {
        if (!part) return null;
        if (i % 2 === 1) {
          const href = part.startsWith('http') ? part : `https://${part}`;
          return (
            <a key={i} href={href} target="_blank" rel="noopener noreferrer" className={className} data-testid="message-link">
              {part}
            </a>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
};

/* Defence-in-depth: never render an email address where a name belongs. */
export const safeName = (value, fallback) =>
  value && !/\S+@\S+\.\S+/.test(value) ? value : fallback;
